/**
 * Legal Pages Configuration
 *
 * Central configuration for all legal document links.
 * Published legal documents for LSN lab.
 */

export const LEGAL_LINKS = {
  /**
   * Privacy Policy - How we collect, use, and protect user data
   * @url https://lsnlab.com/legal/privacy
   */
  PRIVACY_POLICY: "https://lsnlab.com/legal/privacy",

  /**
   * Terms of Service - Rules and conditions for using LingoShade
   * @url https://lsnlab.com/legal/terms
   */
  TERMS_OF_SERVICE: "https://lsnlab.com/legal/terms",

  /**
   * Cookie Policy - Detailed information about cookies we use
   * @url https://lsnlab.com/legal/cookies
   */
  COOKIE_POLICY: "https://lsnlab.com/legal/cookies",
} as const;

/**
 * Helper function to open legal documents in new tab
 */
export const openLegalDocument = (url: string): void => {
  window.open(url, "_blank", "noopener,noreferrer");
};

/**
 * Link props for React components
 * Ensures consistent security attributes across all legal links
 */
export const legalLinkProps = {
  target: "_blank",
  rel: "noopener noreferrer",
} as const;

export default LEGAL_LINKS;
